const defaultLogoURL = "https://s3.us-east-2.amazonaws.com/public.curatedplanet.com/logo/curatedplanet_horizontal.png";

export const makeURL = (base, p, preset, s) => {
    if (!base) {
        console.warn(`images.makeURL: image base URL is undefined`);
        return null;
    }
    const chunks = [p];
    if (preset) {
        chunks.push(preset);
    }
    chunks.push(s);
    const image = chunks.join('/').replace(/\//g, '%2f');
    return `${base}${image}`;
};

export const logo = (top, preset) => {
    if (!top) {
        console.warn(`images.logo: no tour operator data found in local storage, using default logo`);
        return defaultLogoURL;
    }
    if (!top.logo || !top.logo.p || !top.logo.s) {
        console.warn(`images.logo: tour operator logo is not defined, using default logo: ${top.logo}`);
        return defaultLogoURL;
    }
    return makeURL(top.logo.p, preset, top.logo.s);
};

export const imageURL = (base, img, preset) => {
    if (!img || !img.p || !img.s) {
        console.warn(`images.imageURL: image or it's prefix or suffix is not defined: ${img}`);
        return null;
    }
    return makeURL(base, img.p, preset, img.s);
};

const imagesAPI = {
    logo: logo,
    makeURL: makeURL,
    url: imageURL,
};

export default imagesAPI;
